import ModalOutcomesEventHistoryInfo from "./ModalOutcomesEventHistoryInfo";

export default ModalOutcomesEventHistoryInfo;